jQuery(document).ready(function() {

  // jQuery(".product-review .jdgm-rev-widg__header").html("<h2 class='jdgm-rev-widg__title'>Customer <span>Reviews</span></h2>"); 
  
  jQuery('.useraccount a').click(function(){
    jQuery(this).toggleClass('active');
  });

    jQuery(window).scroll(function() {
      
	  if (jQuery(this).scrollTop() > 1){  
	    jQuery('.header-wrapper').addClass("sticky");
	  }
	  else{
	    jQuery('.header-wrapper').removeClass("sticky");
	  }
	});

   
    jQuery(".product-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true, // Enable infinite scrolling
      autoplay: true, // Enable autoplay
      autoplaySpeed: 3000, // Slide every 3 seconds (3000 milliseconds)
      dots: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 425,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
      // Add any additional configuration options as needed
    });

    

  jQuery(".brands-responsive").slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow:6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
 
    arrows: true, // Enable arrows
  prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Prev</button>',
  nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

   jQuery(".blog-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true, // Enable infinite scrolling
      autoplay: true, // Enable autoplay
      autoplaySpeed: 3000, // Slide every 3 seconds (3000 milliseconds)
      dots: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 736,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 425,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
      // Add any additional configuration options as needed
    });

     jQuery(window).on("scroll", function () {
      
     jQuery(".related-products-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
      // Add any additional configuration options as needed
    });
  });
 
});
